/**
 * Ссылка на карточку сделки. Поддомен у каждого аккаунта свой, поэтому база приходит с сервера
 * (`GET /api/v1/integrations/amo/account`): зашитый `www.amocrm.ru` уводил в чужой аккаунт.
 */
export function amoLeadUrl(baseUrl: string, leadId: number): string {
  return `${baseUrl.replace(/\/$/, "")}/leads/detail/${leadId}`;
}
